// extracted by mini-css-extract-plugin
export default {"container":"ModalFolder_container__GhiM4","header":"ModalFolder_header__i2Gm2","wrapperButton":"ModalFolder_wrapperButton__flFrt"};